import { createContext, useContext } from "react";
import { DialogService } from "./types";

export const DialogContext = createContext<DialogService | null>(null);

export const useDialogService = () => {
  const context = useContext(DialogContext);

  if (!context) {
    throw new Error("DialogService is not available. Wrap app with DialogProvider.");
  }

  return context;
};
